module.exports = {
    googleSem: {
        storeCodeParamPrefix: 'woolworths_supermarkets_',
        defaultBasePriceStoreCode: 1649, // New South Wales
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/google-sem.js